import React from 'react';

const TitleWithLine = ({ text }) => {
  return (
    <div className='mb-5'>
      <h1 className="openSansItalic mt-4 static-title">{text}</h1>
    </div>
  );
};

export default TitleWithLine;
